import type { IconGlyph } from '../icon';

/**
 * Tractie `check` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/check.jsx`.
 */
export const iconCheck: IconGlyph = {
  name: 'check',
  path: 'M18.82 6.12a.493.493 0 0 0-.7.06l-8.13 9.56-4.12-4.58a.504.504 0 0 0-.71-.04c-.21.18-.22.5-.04.71L10 17.25l8.87-10.44c.18-.21.15-.53-.06-.7Z',
};
